
import React from 'react';
import { Download } from 'lucide-react';

const PressResourcesCard = () => {
  return (
    <section className="mb-16">
      <div className="vintage-card p-6 text-center">
        <h2 className="font-playfair text-2xl font-bold mb-4">Press Releases, Logos, and More</h2>
        <p className="mb-6 text-text/80">Access our official press resources, high-resolution images, and brand assets.</p>
        <a 
          href="https://drive.google.com/drive/u/0/folders/13a4d-KbkxPIjZVBBEP8TLQPhYvQgrqii?pli=1" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn-accent inline-flex items-center hover:text-white"
        >
          <Download size={18} className="mr-2" />
          Access Press Materials
        </a>
      </div>
    </section>
  );
};

export default PressResourcesCard;
